"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const messages_1 = require("./messages");
const router_1 = require("@keplr-wallet/router");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.EnableAccessMsg:
                return handleEnableAccessMsg(service)(env, msg);
            case messages_1.GetPermissionOriginsMsg:
                return handleGetPermissionOriginsMsg(service)(env, msg);
            case messages_1.GetOriginPermittedChainsMsg:
                return handleGetOriginPermittedChainsMsg(service)(env, msg);
            case messages_1.AddPermissionOrigin:
                return handleAddPermissionOrigin(service)(env, msg);
            case messages_1.RemovePermissionOrigin:
                return handleRemovePermissionOrigin(service)(env, msg);
            default:
                throw new router_1.KeplrError("permission", 120, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleEnableAccessMsg = (service) => {
    return (env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        return yield service.checkOrGrantBasicAccessPermission(env, msg.chainIds, msg.origin);
    });
};
const handleGetPermissionOriginsMsg = (service) => {
    return (_, msg) => {
        return service.getPermissionOrigins(msg.chainId, msg.permissionType);
    };
};
const handleGetOriginPermittedChainsMsg = (service) => {
    return (_, msg) => {
        return service.getOriginPermittedChains(msg.permissionOrigin, msg.permissionType);
    };
};
const handleAddPermissionOrigin = (service) => {
    return (_, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.addPermission([msg.chainId], msg.permissionType, [
            msg.permissionOrigin,
        ]);
    });
};
const handleRemovePermissionOrigin = (service) => {
    return (_, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.removePermission(msg.chainId, msg.permissionType, [
            msg.permissionOrigin,
        ]);
    });
};
//# sourceMappingURL=handler.js.map